import { apiJson } from './client.js';

function toFormData(payload = {}) {
  const form = new FormData();
  Object.entries(payload).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    if (key === 'files' && Array.isArray(value)) {
      value.forEach((file) => { if (file) form.append('files', file); });
      return;
    }
    if (typeof File !== 'undefined' && value instanceof File) form.append('file', value);
    else form.append(key, String(value));
  });
  return form;
}

export async function getCustomContents({ modelId, fanId, status, limit = 100, offset = 0 } = {}) {
  const params = new URLSearchParams({ limit, offset });
  if (modelId != null && modelId !== '') params.set('model_id', modelId);
  if (fanId != null && fanId !== '') params.set('fan_id', fanId);
  if (status) params.set('status', status);
  return apiJson(`/admin/custom-contents?${params}`, {}, 'Failed to load custom content');
}

export async function createCustomContent(payload = {}) {
  return apiJson(
    '/admin/custom-contents',
    { method: 'POST', body: toFormData(payload), skipContentType: true },
    'Failed to create custom content order',
  );
}

export async function updateCustomContent(orderId, payload = {}) {
  return apiJson(
    `/admin/custom-contents/${orderId}`,
    { method: 'PATCH', body: toFormData(payload), skipContentType: true },
    'Failed to update custom content order',
  );
}

export async function prepareCustomContentForFansly(orderId) {
  return apiJson(
    `/admin/custom-contents/${orderId}/prepare-fansly`,
    { method: 'POST' },
    'Failed to prepare custom content for Fansly',
  );
}

export async function recordCustomContentSend(orderId, { confirmed = true, sentMessageId } = {}) {
  const payload = { confirmed: Boolean(confirmed) };
  if (sentMessageId != null && sentMessageId !== '') payload.sent_message_id = sentMessageId;
  return apiJson(
    `/admin/custom-contents/${orderId}/record-send`,
    { method: 'POST', body: toFormData(payload), skipContentType: true },
    'Failed to record manual delivery',
  );
}

export async function resetCustomContentDelivery(orderId, { confirmedNotSent = false } = {}) {
  return apiJson(
    `/admin/custom-contents/${orderId}/reset-delivery`,
    {
      method: 'POST',
      body: toFormData({ confirmed_not_sent: Boolean(confirmedNotSent) }),
      skipContentType: true,
    },
    'Failed to reset custom delivery',
  );
}
